import "../edit.css";
import { Icon } from "../../icon";
import { BoxProps, WrapperProps } from "./wrapper.props";

export const Wrapper: React.FC<WrapperProps> = ({
  orientation = "horizontal",
  children,
}) => {
  return (
    <div
      className={`edit-wrapper ${
        orientation === "horizontal" ? "horizontal" : "vertical"
      }`}
    >
      {children}
    </div>
  );
};

export const Box: React.FC<BoxProps> = ({
  show = true,
  className,
  children,
  actions,
  error = "",
  isDisabled = false,
}) => {
  let isError: boolean = error.length > 0;

  return (
    <>
      <div
        className={`edit-box-wrapper ${!show ? "none" : ""} ${
          isError ? "error" : ""
        } ${className}`}
      >
        {actions?.left !== undefined && actions.left.show && (
          <button
            className={`edit-box-action left ${
              actions.left.disabled || isDisabled ? "disabled" : ""
            } ${actions.left.className}`}
            onClick={actions.left.onClick}
            disabled={actions.left.disabled || isDisabled}
          >
            <Icon
              className="edit-box-action-icon"
              icon={actions.left.icon}
              alt={`Action Left`}
            />
          </button>
        )}

        <div className={`edit-box-content ${isDisabled ? "disabled" : ""}`}>
          {children}
          {isError && <span className="edit-box-error">{error}</span>}
        </div>

        {actions?.right !== undefined && actions.right.show && (
          <button
            className={`edit-box-action right ${
              actions.right.disabled || isDisabled ? "disabled" : ""
            } ${actions.right.className}`}
            onClick={actions.right.onClick}
            disabled={actions.right.disabled || isDisabled}
          >
            <Icon
              className="edit-box-action-icon"
              icon={actions.right.icon}
              alt={`Action Right`}
            />
          </button>
        )}
      </div>
    </>
  );
};
